<p-card [styleClass]="getClassView()">
  <div class="card-route">
    <div class="row">
      <span>{{'ERRO.' + getTextView() | translate}}</span>
    </div>
  </div>
</p-card>
